<template>
  <div
    class="collection-ape-trait"
    :class="{ 'gender-both': genderId === 3, [`rarity-${rarity}`]: true }"
  >
    <div class="collection-ape-trait__category">
      {{ item.categoryName }}
    </div>
    <div
      v-if="item.balance > 1"
      v-tooltip="'You have ' + item.balance + ' such traits in the wallet'"
      class="collection-ape-trait__count"
    >
      <IWallet width="14" />
      {{ item.balance }}
    </div>
    <div
      v-if="genderId === 3"
      class="collection-ape-trait__images"
    >
      <div
        class="collection-ape-trait__image"
        @click.prevent="$emit('zoom', maleImage)"
      >
        <img
          :src="maleImage"
          alt="male"
          loading="lazy"
        >
        <div class="collection-ape-trait__image-info">
          Male
        </div>
      </div>
      <div
        class="collection-ape-trait__image"
        @click.prevent="$emit('zoom', femaleImage)"
      >
        <img
          :src="femaleImage"
          alt="female"
          loading="lazy"
        >
        <div class="collection-ape-trait__image-info">
          Female
        </div>
      </div>
    </div>
    <div
      v-else
      class="collection-ape-trait__images"
    >
      <div class="collection-ape-trait__image">
        <img
          :src="previewImage"
          alt="preview"
          loading="lazy"
          @click.prevent="$emit('zoom', previewImage)"
        >
        <div class="collection-ape-trait__image-info">
          {{ genderId === 1 ? 'Male' : 'Female' }}
        </div>
      </div>
    </div>
    <div class="collection-ape-trait__name">
      {{ item.name }}
    </div>
    <div class="collection-ape-trait__minted-count">
      {{ item.total_minted }} Minted
    </div>
    <div
      class="collection-ape-trait__rarity"
      :class="rarity"
    >
      {{ rarityName }}
    </div>
  </div>
</template>
<script>
import { ApeTraitRarity } from "@/helpers/ape-constructor/ape-trait-rarity"
import { computed, defineComponent } from "vue"
import IWallet from "@/assets/icons/ape-constructor/ape-constructor-wallet.svg?inline"
export default defineComponent({
    components: { IWallet },
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    },
    setup(props) {
        // add gender id, rarity, and balance to trait card
        const genderId = computed(() => props.item.genderId)
        const maleImage = computed(() => props.item.malePreviewImageSrc)
        const femaleImage = computed(() => props.item.femalePreviewImageSrc)
        const previewImage = computed(() => maleImage.value || femaleImage.value)
        const rarityName = computed(() => props.item.rarity ? props.item.rarity.charAt(0).toUpperCase() + props.item.rarity.slice(1) : '')
        const rarity = computed(() => {
            if (props.item.rarity === ApeTraitRarity.og) return 'common'
            return props.item.rarity
        })
        return {
            previewImage, rarityName, genderId, maleImage, femaleImage, rarity
        }
    }
})
</script>
<style lang="scss">
.collection-ape-trait {
    border: 1px solid var(--border);
    padding: 10px;
    padding-top: 24px;
    padding-bottom: 28px;
    border-radius: 5px;
    box-shadow: 0 0 4px 3px var(--rarity-common);
    position: relative;
    &__category {
        text-transform: uppercase;
        font-weight: bold;
        padding: 5px 14px;
        box-sizing: border-box;
        background-color: var(--gray-light);
        display: inline-block;
        border-radius: 20px;
        font-size: 14px;
        position: absolute;
        top: 0;
        left: 50%;
        white-space: nowrap;
        transform: translate(-50%, -50%);
    }
    &__minted-count {
        font-size: 12px;
        opacity: 0.5;
    }
    &__count {
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(40%, -40%);
        position: absolute;
        background-color: var(--gray-light);
        border: var(--border);
        border-radius: 5px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 3px 5px;
        text-align: center;
        min-width: 26px;
        font-size: 16px;
        font-weight: bold;
        color: var(--primary);
        svg {
            margin-right: 2px;
        }
    }
    &__rarity {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        position: absolute;
        height: 20px;
        left: 0;
        right: 0;
        bottom: 0;
        font-size: 14px;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        &.common {
            background-color: var(--rarity-common);
        }
        &.epic {
            background-color: var(--rarity-epic);
        }
        &.legendary {
            background-color: var(--rarity-legendary);
        }
    }
    &__count {
    }
    &__name {
        font-weight: bold;
        color: var(--primary);
        margin-top: 5px;
    }
    &__images {
        display: flex;
        justify-content: center;
        img {
            max-width: 100%;
            height: auto;
            width: 100%;
            border-radius: 5px;
        }
    }
    &__image {
        cursor: zoom-in;
        max-width: 50%;

        &-info {
            opacity: 0.5;
            text-transform: uppercase;
            font-size: 12px;
            font-weight: bold;
        }
    }
    &.gender-both & {
        &__images {
            img {
            }
        }
        &__image {
            flex: 1;
            &:first-child {
                margin-right: 5px;
            }
        }
    }

    &.rarity-epic {
        box-shadow: 0 0 4px 0 var(--rarity-epic);
    }
    &.rarity-legendary {
        box-shadow: 0 0 4px 0 var(--rarity-legendary);
    }
}
</style>